'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dist = require('./dist');

Object.keys(_dist).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dist[key];
    }
  });
});
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/index.js